import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import Money from '../../../../../../../../../../components/TableCell/components/Money'
import { formatValueByBase } from '../../../../../../../../../../components/FormattedNumber/helpers'

import { LOCALE_PREFIX } from '../../../Blocks/PaymentIndex/constants'
import { types } from '../../constants'
import { getHighestLevel } from '../../helpers'
import { fields } from './constants'

import './style.scss'

export default class DataTable extends Component {
    static propTypes = {
        type: PropTypes.string,
        sector: PropTypes.object,
        subject: PropTypes.object,
        level: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            firm: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            sector: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            numberOfSuppliers: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            numberOfInvoices: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            paymentDue: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            paymentDueAverage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            paymentDueModus: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            paymentDueMax: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    renderAmount = (entity) => (
        <Money
            emptyValue={'-'}
            value={{
                amount: entity?.amount,
                currency: entity?.currency,
            }}
        />
    )

    renderField = (entity, selector) => {
        if (['paymentDue', 'paymentDueAverage', 'paymentDueModus', 'paymentDueMax'].includes(selector)) {
            return this.renderDue(entity?.[selector])
        }

        return formatValueByBase(entity?.[selector], 1, 0)
    }

    renderDue = (dueData) => {
        if (_.isNil(dueData)) return '-'

        return (
            <FormattedMessage
                id={`${LOCALE_PREFIX}.renderDue`}
                values={{
                    dueData,
                }}
            />
        )
    }

    render() {
        const { type, translates, subject, sector, level } = this.props

        const parsedLevel = getHighestLevel(level)

        return (
            <div className={'payment-informations-data-table'}>
                <div className={'data-table-row'}>
                    <div />
                    <div className={cx('subject-icon', 'visible')}>{translates.firm}</div>
                    <div
                        className={cx(
                            'sector-icon',
                            type === types.QUARTER_TYPE && 'hidden',
                            parsedLevel < 20 && 'hidden'
                        )}
                    >
                        {translates.sector}
                    </div>
                </div>
                {_.map(fields, (field) => {
                    return (
                        <div
                            className={cx('data-table-row', { break: field === 'totalInvoiceAmount' })}
                            key={`payment-data-table-${field}`}
                        >
                            <div>{translates?.[field]}</div>
                            <div>
                                {field !== 'totalInvoiceAmount'
                                    ? this.renderField(subject, field)
                                    : this.renderAmount(subject?.[field])}
                            </div>
                            <div
                                className={cx(
                                    'purple',
                                    type === types.QUARTER_TYPE && 'hidden',
                                    parsedLevel < 20 && 'hidden'
                                )}
                            >
                                {field !== 'totalInvoiceAmount'
                                    ? this.renderField(sector, field)
                                    : this.renderAmount(sector?.[field])}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}
